import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMicrophone,
  faCircleNotch,
  faStop,
} from "@awesome.me/kit-70c1f0055f/icons/classic/regular";
import { useTextToSpeech } from "./useTextToSpeech";

interface TextToSpeechButtonProps {
  textToSpeak: string;
  className?: string;
}

// Speech is synthesised by the API (POST /speech/synthesize) with a browser
// fallback. No provider key may ever be read or held in the browser.
const TextToSpeechButton: React.FC<TextToSpeechButtonProps> = ({
  textToSpeak,
  className,
}) => {
  const { isLoading, isPlaying, error, toggle } = useTextToSpeech(textToSpeak);

  const currentIcon = isLoading
    ? faCircleNotch
    : isPlaying
    ? faStop
    : faMicrophone;

  const buttonTitle = isLoading
    ? "Generating speech..."
    : isPlaying
    ? "Stop speech"
    : "Play text as speech";

  return (
    <button
      onClick={toggle}
      disabled={isLoading && !isPlaying}
      className={`p-2 rounded-full flex items-center justify-center size-10 focus:outline-none focus:ring-2 flex-none focus:ring-indigo-500 ${
        isLoading && !isPlaying
          ? "cursor-not-allowed opacity-70"
          : "cursor-pointer hover:bg-slate-200 dark:hover:bg-slate-600"
      } ${className || ""}`}
      title={buttonTitle}
    >
      <FontAwesomeIcon
        icon={currentIcon}
        spin={isLoading}
        className="text-xl"
      />
      {error && <p className="text-xs text-red-500 mt-1">{error}</p>}
    </button>
  );
};

export default TextToSpeechButton;
